var map = {
	"./Cruise Bingo.png": 668,
	"./Election Hockey.png": 669,
	"./Election Hockey2.jpg": 670,
	"./Football Frenzy.png": 671,
	"./Football Frenzy2.jpg": 672,
	"./Jackpot.png": 673,
	"./Let it Snow Bingo.png": 674,
	"./Plinko.png": 675,
	"./Plinko_.png": 676,
	"./St Pattys Plinko.png": 677,
	"./St. Pattys Plinko.png": 678,
	"./arcade_machine.png": 679,
	"./arcade_machine2.jpg": 680
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 667;


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/multiplayer_card_images nonrecursive \.(png|jpe?g|svg)$
// module id = 667
// module chunks = 0